import React, { useState } from 'react'
import './payment.scss'
import { SubmittedSuccessfulIcon, Button } from '../../lib/components'
import { WhoopInvestmentConfirmationModal } from '../../lib/components/WhoopInvestmentConfirmationModal'
import { OpportunityDetails } from '../../lib/types'

type Props = {
  handleViewSummary: () => void
  opportunity: OpportunityDetails
}

const WHOOP_OPPORTUNITY_SLUG = 'whoop-inc'

const PaymentSubmittedSuccessful = ({ handleViewSummary, opportunity }: Props) => {
  const [showWhoopConfirmationModal, setShowWhoopConfirmationModal] = useState(
    opportunity.projectSlug === WHOOP_OPPORTUNITY_SLUG,
  )

  return (
    <div className='payment-submitted-success' data-testid='payment-submitted-success'>
      <WhoopInvestmentConfirmationModal
        active={showWhoopConfirmationModal}
        handleOnClose={() => setShowWhoopConfirmationModal(false)}
      />
      <div className='payment-submitted-success__inner'>
        <div className='payment-submitted-success__icon-ring' aria-hidden>
          <SubmittedSuccessfulIcon width='88' height='84' />
        </div>
        <h1 className='payment-submitted-success__title'>
          Investment request submitted successfully
        </h1>
        <p className='payment-submitted-success__subtitle'>
          Your request for <strong>{opportunity.projectName}</strong> is being processed. The
          investment remains subject to the fund manager&apos;s allocation decision.
        </p>
        <p className='payment-submitted-success__hint'>
          Your payment is done. Check your email for confirmation and updates on your order.
        </p>
        <Button
          classes={['payment-submitted-success__cta']}
          variant='primary-btn'
          text='View summary'
          handleClick={handleViewSummary}
        />
      </div>
    </div>
  )
}

export { PaymentSubmittedSuccessful }
